import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const VideoIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M3.61359 1L16.0227 1C17.1649 1 18.0909 1.89543 18.0909 3V13C18.0909 14.1046 17.1649 15 16.0227 15H3.61359C2.47137 15 1.54541 14.1046 1.54541 13L1.54541 3C1.54541 1.89543 2.47137 1 3.61359 1ZM3.61359 1L5.68177 4M1.54541 4H18.0909M13.9545 1L16.0227 4M10.8522 1L12.9204 4M6.71586 1L8.78405 4M7.74996 8.61803V10.382C7.74996 11.1253 8.55894 11.6088 9.24651 11.2764L11.0706 10.3944C11.8327 10.0259 11.8327 8.9741 11.0706 8.60557L9.24651 7.72361C8.55894 7.39116 7.74996 7.87465 7.74996 8.61803Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgCommon>
  );
};